import { useRef, useState } from "react";
import { forgotEmailStep } from "../interface/IForgotEmail";
import { postRecoverEmailGenerateOtpRoute, RECOVER_EMAIL_VALIDATE_OTP_ROUTE } from "@api-routes";
import { getStateToPayload as getPhoneNumberStateToPayload } from "../mappers/postPhoneNumberMapper";
import {
    getResponseToState as getRecoverEmailApiResponseToState,
    getStateToPayload as getVerificationCodeStateToPayload,
    IRecoverEmailApiResponse,
} from "../mappers/postVerificationCodeMapper";
import { useFetch } from "@common/hook/useFetch";
import { BRAND_NAME } from "@constants";
import { getLanguage } from "@utils/changeLanguage";

export const useForgotEmail = () => {
    const [actualStep, setActualStep] = useState(forgotEmailStep.initial);
    const [recoverEmail, setRecoverEmail] = useState("");
    const lang = getLanguage();
    const [postPhoneNumberState, { post: postPhoneNumberCaller }] = useFetch();
    const [postVerificationCodeState, { post: postVerificationCodeCaller }] = useFetch();
    const [mobileNumber, setMobileNumber] = useState<string>("");
    const [isValidOtp, setIsValidOtp] = useState<boolean>(true);

    const checkPhoneNumber = (phoneNumber: string) => {
        postPhoneNumberCaller<boolean>(postRecoverEmailGenerateOtpRoute(lang), {
            body: getPhoneNumberStateToPayload(phoneNumber, BRAND_NAME),
        }).then((postPhoneNumberResponse) => {
            if (postPhoneNumberResponse) {
                setMobileNumber(phoneNumber);
                setActualStep(forgotEmailStep.verificationCode);
            }
        });
    };

    const checkVerificationCode = (verificationCode: string) => {
        console.log("checkVerificationCode - mobileNumber: " + mobileNumber);
        postVerificationCodeCaller<IRecoverEmailApiResponse>(RECOVER_EMAIL_VALIDATE_OTP_ROUTE, {
            body: getVerificationCodeStateToPayload(verificationCode, mobileNumber, BRAND_NAME),
        }).then((recoverEmailApiResponse) => {
            if (recoverEmailApiResponse) {
                const { email, isVerified, validOtp } = getRecoverEmailApiResponseToState(recoverEmailApiResponse);

                setIsValidOtp(validOtp);
                if (validOtp) {
                    setRecoverEmail(email);
                    const step = isVerified ? forgotEmailStep.success : forgotEmailStep.emailNotVerified;
                    setActualStep(step);
                }
            }
        });
    };

    const goToInitialStep = () => {
        setIsValidOtp(true);
        setActualStep(forgotEmailStep.initial);
    };

    return {
        actualStep,
        checkPhoneNumber,
        checkVerificationCode,
        goToInitialStep,
        postPhoneNumberState,
        postVerificationCodeState,
        recoverEmail,
        isValidOtp,
    };
};
